import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

export const getAuditDashList = createAsyncThunk('/audit_list/content', async (nopage) => {
    const response = await axios.get(`${process.env.REACT_APP_API_ENDPOINT}/companyAuditHistoryList?page=${nopage}`, {})
    return response.data;
})

export const auditListSlice = createSlice({
    name: 'audit_list',
    initialState: {
        isLoading: false,
        audit_list: []
    },

   
    extraReducers: (builder) => {
        builder
            .addCase(getAuditDashList.pending, (state) => {
                state.isLoading = true;
            })               
            .addCase(getAuditDashList.fulfilled, (state, action) => {
                state.audit_list = action.payload.data;
                state.isLoading = false;
            })               
            .addCase(getAuditDashList.rejected, (state) => {
                state.isLoading = false;
            });               
    }   
})

export default auditListSlice.reducer